import type { BonusSamplePrompt } from '../types/domain';

export const BONUS_SAMPLE_PROMPT_MAX_ENTRIES = 40;
export const BONUS_SAMPLE_PROMPT_MAX_TITLE_CHARS = 120;
export const BONUS_SAMPLE_PROMPT_MAX_PROMPT_CHARS = 4_000;

function readString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

export function normalizeBonusSamplePrompts(value: unknown): BonusSamplePrompt[] {
  if (!Array.isArray(value)) return [];
  return value.map((entry) => {
    const prompt = entry && typeof entry === 'object' ? (entry as Partial<BonusSamplePrompt>) : {};
    return { title: readString(prompt.title).trim(), prompt: readString(prompt.prompt) };
  });
}

export function validateBonusSamplePrompts(prompts: readonly BonusSamplePrompt[]): string | null {
  if (prompts.length === 0) return 'Add at least one instrumental loop prompt.';
  if (prompts.length > BONUS_SAMPLE_PROMPT_MAX_ENTRIES) {
    return `Add up to ${BONUS_SAMPLE_PROMPT_MAX_ENTRIES} instrumental loop prompts per pack.`;
  }
  for (const [index, entry] of prompts.entries()) {
    if (!entry.title.trim()) return `Add a title for loop prompt ${index + 1}.`;
    if (!entry.prompt.trim()) return `Add the prompt for "${entry.title.trim()}".`;
    if (entry.title.length > BONUS_SAMPLE_PROMPT_MAX_TITLE_CHARS) {
      return `Keep loop prompt ${index + 1}'s title under ${BONUS_SAMPLE_PROMPT_MAX_TITLE_CHARS} characters.`;
    }
    if (entry.prompt.length > BONUS_SAMPLE_PROMPT_MAX_PROMPT_CHARS) {
      return `Keep "${entry.title.trim()}" under ${BONUS_SAMPLE_PROMPT_MAX_PROMPT_CHARS.toLocaleString('en-US')} characters.`;
    }
  }
  return null;
}
